import React, { useReducer } from "react";
import { RESET_SUBMISSION, UPDATE_SUBMISSION } from "../../constants/common";
import SubmissionContext from "./submission-context";
import submissionReducer from "./submission-reducer";
var SubmissionState = function (_a) {
    var children = _a.children;
    var _b = useReducer(submissionReducer, {
        data: {},
    }), submissionState = _b[0], dispatch = _b[1];
    var updateSubmission = function (data) {
        dispatch({ type: UPDATE_SUBMISSION, payload: data });
    };
    var resetSubmission = function () {
        dispatch({ type: RESET_SUBMISSION });
    };
    return (React.createElement(SubmissionContext.Provider, { value: { submission: submissionState, updateSubmission: updateSubmission, resetSubmission: resetSubmission } }, children));
};
export default SubmissionState;
//# sourceMappingURL=SubmissionState.js.map